import API from '../../api';

const API_URI = '/v2/signup';

export default {
  signup(params) {
    return API.request('post', API_URI, params);
  },
  existing(params) {
    return API.request('post', API_URI + '/existing', params);
  },
  resubmitAddress(params) {
    return API.request('patch', API_URI + '/resubmit/address', params);
  }
}
